"use strict";
const { RECIPIENT_TYPES: { ADHOC, CONTACT, USER, DISTRIBUTION_LIST, VARIABLE }, } = require('../../constants');
exports.generateDistributionListRecipient = ({ iuxId }) => ({
    type: DISTRIBUTION_LIST,
    iuxId,
});
exports.generateContactRecipient = ({ iuxId }) => ({
    type: CONTACT,
    iuxId,
});
exports.generateUserRecipient = ({ iuxId }) => ({
    type: USER,
    iuxId,
});
exports.generateAdhocRecipient = ({ value }) => ({
    type: ADHOC,
    value,
});
exports.generateVariableRecipient = ({ stepId, variableId }) => ({
    type: VARIABLE,
    stepId,
    variableId,
});
//# sourceMappingURL=recipientFactory.js.map